import { theme } from 'antd';

const brandToken = {
  colorPrimary: "#38b549",
  colorPrimaryBg: "#e6f7e9",
  colorPrimaryBgHover: "#c2f0c9",
  colorPrimaryBorder: "#95e09e",
  colorPrimaryBorderHover: "#6ad378",
  colorPrimaryHover: "#2d9e3e",
  colorPrimaryActive: "#1f7a2d",
  colorPrimaryText: "#38b549",
  colorPrimaryTextHover: "#2d9e3e",
  colorPrimaryTextActive: "#1f7a2d",
  colorSuccess: "#00b42a",
  colorSuccessBg: "#e8ffea",
  colorSuccessBgHover: "#c2ffcb",
  colorSuccessBorder: "#92f2a2",
  colorSuccessBorderHover: "#5ad975",
  colorSuccessHover: "#23c343",
  colorSuccessActive: "#009a29",
  colorSuccessText: "#00b42a",
  colorSuccessTextHover: "#23c343",
  colorSuccessTextActive: "#009a29"
};

const darkBrandToken = {
  ...brandToken,
  colorPrimaryBg: "#1f3a23", // Darker green background
  colorSuccessBg: "#132f18",
  colorBgBase: "#141414", // AntD default dark bg
  colorBgContainer: "#1f1f1f",
};

export const getTheme = (isDark) => {
  return {
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
        ...(isDark ? darkBrandToken : brandToken),
        colorTextPlaceholder: isDark ? 'rgba(255, 255, 255, 0.45)' : '#595959',
        colorTextDescription: isDark ? 'rgba(255, 255, 255, 0.45)' : '#595959',
    },
    components: {
      Input: {
        colorText: isDark ? 'rgba(255, 255, 255, 0.95)' : '#000000',
        fontWeight: 500,
      },
      Card: {
        colorBorderSecondary: isDark ? '#434343' : '#d9d9d9',
      }
    }
  };
};

// Keep deprecated export for backward compatibility until fully migrated if needed
export const themeAntD = {
  token: brandToken
};
